/**
 * Removes a sub-form from form validation
 *
 * @example
 * <form>
 *   <ng-form tmr-isolate-form></ng-form>
 * </form>
 *
 * @namespace
 * @alias tmrIsolateForm
 * @type {ngDirective}
 */
function tmrIsolateFormDirective() {
  'ngInject'
  return {
    restrict: 'A',
    require: '^form',
    link: function ($scope, $element, $attr, $ctrl) {
      // Remove this form from parent controller
      if ($ctrl && $ctrl.$$parentForm) $ctrl.$$parentForm.$removeControl($ctrl)
    },
  }
}

export const directive = ['tmrIsolateForm', tmrIsolateFormDirective]
